import { Typography } from 'components/_common/Typography';
import React from 'react';

type CaptionWithSubtitleProps = {
  caption: string;
  subtitle: string;
};
const CaptionWithSubtitle: React.FC<CaptionWithSubtitleProps> = ({ caption, subtitle }) => {
  return (
    <>
      <Typography variant="caption" color="deepSea50" marginBottom="9px">
        {caption}
      </Typography>
      <Typography variant="subtitle2" color="stone90">
        {subtitle}
      </Typography>
    </>
  );
};
export default CaptionWithSubtitle;
